import React from 'react'

function Downloads() {
  return (
    <div>Downloads</div>
  )
}

export default Downloads